import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { AfterViewInit, Component, OnInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { DealerService } from "./../../../../../services/seed/dealer.service";
import { LoaderService } from './../../../../../services/infrastructure/loader.service';
import { CommonService } from './../../../../../services/common/common.service';
import { BroadcastService } from './../../../../../services/infrastructure/broadcaster.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../../common/shared/lol-logger.service';
import { EaProductModifyDecreaseUnitSliderModelService } from './ea-product-modify-decrease-unit-slider-model.service';
import { ConfigService } from '../../../../../services/infrastructure/config.service';
import { Router } from '@angular/router';

@Component({
  selector: "app-ea-product-modify-decrease-unit",
  templateUrl: "./ea-product-modify-decrease-unit.component.html",
  styleUrls: ["./ea-product-modify-decrease-unit.component.scss"],
})
export class EaProductModifyDecreaseUnitComponent
  implements OnInit, AfterViewInit {
  private subscription = new Array<Subscription>();
  eaModifyProductDS: MatTableDataSource<any>;
  isNavModify: boolean
  totalEaUnits: number = 0;
  totalEaModifiableUnits: number = 0;
  totalOldEaModifiableUnits: number = 0;
  eaModifyProductDSCopy: any;
  webOrderNumber: any;
  accountNumber: any;
  dealerOrderId: any;
  errorMsgs = new Array();
  showErrorBlock
  currentErrorRow = 1;
  nextErrorId = 0;
  index = 0;
  hasChangeAdded = false;
  displayColumns: string[] = [
    "productName",
    "seedSize",
    "packageSize",
    "treatment",
    "eaUnits",
    "eaModifiableUnits",
  ];
  constructor(private dealerService: DealerService,
    private toastrService: ToastrService,
    private broadcastService: BroadcastService,
    public commonService: CommonService,
    private loaderService: LoaderService,
    private configService: ConfigService,
    private router: Router,
    private eaProductModifyDecreaseUnitSliderModelService: EaProductModifyDecreaseUnitSliderModelService) { }

  ngOnInit(): void {
    this.isNavModify = this.dealerService.isNaveForModify;
    this.webOrderNumber = this.dealerService.selectedProductForModificaionOrderNumber;
    this.accountNumber = this.dealerService.selectedProductForModificaionAccountNumber;
    this.dealerOrderId = this.dealerService.selectedDealerOrderId
    this.eaModifyProductDS = new MatTableDataSource(this.dealerService.selectedProductForModificaion);
    this.addErrorFields();

    //validate for deactivated item for modify screen
    if (this.isNavModify) {
      this.ValidateSelectedItems(this.eaModifyProductDS.data);
    }
    else {
      this.GetEaMinimumUnitException(this.eaModifyProductDS.data);
    }
  }

  //add extra fields in grid model to display validatin errors
  addErrorFields() {
    this.eaModifyProductDS.data.map((x) => {
      x.isItemQualified = true;
      x.minimumUnits = 0;
      x.totalEaUnits = 0;
      x.groupId = "";
      return x;
    });
  }

  //validate selected items for deactivated item for modify screen
  ValidateSelectedItems(selectedList: any) {
    let payload = []
    selectedList.filter((f) => !f.isGroupBy).map((x) => {
      let tempObj = {
        'dealerOrderItemId': x.dealerOrderItemId,
        'dealerOrderId': x.dealerOrderID,
        'itemId': x.itemID,
        'isSeedEAItemInclusion': false,
        'isSeedEAAccountItemExclusion': false,
        'isDeactivationTypeSuspended': false,
      }
      payload.push(tempObj)
    })
    this.subscription.push(this.dealerService.validateEaModifiableUnitsItem(payload).subscribe(results => {
      if (results) {
        //set validation field in grid model
        results.map((x) => {
          let data = this.eaModifyProductDS.data.find((y) => y.dealerOrderItemId == x.dealerOrderItemId);
          data.isItemQualified = x.isSeedEAItemInclusion && !x.isSeedEAAccountItemExclusion && !x.isDeactivationTypeSuspended;
        });
        this.convertDataForDS(this.eaModifyProductDS.data);
      }
    }, (error => {
      LolLoggerService.error(error);
    })));
  }

  //validate selected items for deactivated item for modify screen
  GetEaMinimumUnitException(selectedList: any) {
    let payload = []
    selectedList.filter((f) => !f.isGroupBy).map((x) => {
      let tempObj = {
        'dealerOrderItemId': x.dealerOrderItemId,
        'accountNumber': x.shipToAccount,
        'itemId': x.itemID,
      }
      payload.push(tempObj)
    })
    this.subscription.push(this.dealerService.getEaMinimumUnitException(payload).subscribe(results => {
      if (results) {
        //set validation field in grid model
        results.map((x) => {
          let data = this.eaModifyProductDS.data.find((y) => y.dealerOrderItemId == x.dealerOrderItemId);
          data.minimumUnits = x.minimumUnit;
          data.totalEaUnits = x.totalEAUnit;
          data.groupId = x.groupId;
          //remove element from list if no minimum unit found
          if (data.minimumUnits <= 0) {
            this.eaModifyProductDS.data.splice(this.eaModifyProductDS.data.indexOf(data), 1);
          }
        });
        this.eaModifyProductDS = new MatTableDataSource(this.eaModifyProductDS.data);
        this.convertDataForDS(this.eaModifyProductDS.data);
      }
    }, (error => {
      LolLoggerService.error(error);
    })));
  }

  //on closing the modle popup
  onCancel() {
    this.eaProductModifyDecreaseUnitSliderModelService.close()
  }

  // Is group
  isGroup(index, item): boolean {
    return item.isGroupBy;
  }

  //convert grid model in group of product line
  convertDataForDS(orderList: any[]) {
    let orderListDS: any[] = [];
    orderList.map((x) => {
      const groupData = orderListDS.filter((y) => y.isGroupBy == true);
      const groupDetail = groupData.find((y) => y.productLine == x.productLine);

      if (groupDetail != undefined) {
        let validate = false,
          rowId = 0;
        groupData.forEach(function (gd) {
          if (validate == true) {
            return;
          }
          if (gd.productLine == x.productLine) {
            validate = true;
            rowId = gd.rowId;
          }
        });

        orderListDS.splice(rowId, 0, x);
      } else {
        const newGroup = {
          isGroupBy: true,
          productLine: x.productLine,
          ProductNameFilter: "",
        };
        groupData.push(newGroup);
        orderListDS.splice(orderList.length, 0, newGroup);
        orderListDS.splice(orderList.length, 0, x);
      }
      orderListDS.sort(function (a, b) {
        const nameA = a.productLine.toLowerCase(),
          nameB = b.productLine.toLowerCase();
        if (nameA < nameB) {
          // sort string ascending
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0; // default return value (no sorting)
      });

      if (orderListDS.length > 0) {
        let newRowId: Number = 0;
        orderListDS.forEach((x) => {
          newRowId = +newRowId + 1;
          x.rowId = +newRowId;
          x.totalRows = 2;
          x.lineErrors = { 'rowId': x.rowId, 'errors': [] };
        });
      }
    });
    this.onClose(orderListDS, false);
  }

  //on close bind the data source
  onClose(selectedProductList: any[], isPopupAction): void {
    if (selectedProductList.length > 0) {
      this.bindDataSource(selectedProductList, true);
    }
  }

  //bind data source with filtered values
  bindDataSource(orderListDS: any, isClone: boolean) {
    if (orderListDS && orderListDS != null) {
      this.eaModifyProductDS = new MatTableDataSource(
        JSON.parse(JSON.stringify(orderListDS))
      );
      if (isClone) {
        this.eaModifyProductDSCopy = JSON.parse(JSON.stringify(orderListDS));

        //calculate total ea units and modifiable units
        this.eaModifyProductDSCopy.filter((f) => !f.isGroupBy).map((x) => {
          this.totalOldEaModifiableUnits = this.totalOldEaModifiableUnits + parseInt(x.eaModifiableUnits)
          this.totalEaUnits = this.totalEaUnits + parseInt(x.eaUnits);
        });
        this.totalEaModifiableUnits = this.totalEaUnits;
      }
      this.eaModifyProductDS.filterPredicate = (data: any, filter: any) => {
        let counter = 0;
        const groupFilterSource = JSON.parse(
          JSON.stringify(this.eaModifyProductDS.data)
        );
        const groupName = data.productLine.toLowerCase();
        for (let i = 0; i < groupFilterSource.length; i++) {
          if (
            groupFilterSource[i].productLine.toLowerCase() == groupName &&
            (groupFilterSource[i].ProductNameFilter == "" ||
              groupFilterSource[i].ProductNameFilter.toLowerCase().indexOf(
                filter.ProductNameFilter.toLowerCase()
              ) > -1)
          ) {
            counter = counter + 1;
          }
        }
        if (
          data.ProductNameFilter == null ||
          data.ProductNameFilter == "undefined"
        ) {
          data.ProductNameFilter = "";
        }
        if (
          ((data.ProductNameFilter == "" && counter > 1) ||
            data.ProductNameFilter.toLowerCase().indexOf(
              filter.ProductNameFilter.toLowerCase()
            ) > -1) &&
          (filter.MarketingBrandList.length == 0 ||
            filter.MarketingBrandList.indexOf(data.marketingBrand) > -1) &&
          (filter.PackageSizeList.length == 0 ||
            filter.PackageSizeList.indexOf(data.packageSize) > -1) &&
          (filter.TreatmentList.length == 0 ||
            filter.TreatmentList.indexOf(data.treatment) > -1) &&
          (filter.SeedSizeList.length == 0 ||
            filter.SeedSizeList.indexOf(data.seedSize) > -1) &&
          (filter.ProductLineList.length == 0 ||
            filter.ProductLineList.indexOf(data.productLine) > -1)
        ) {
          if (counter <= 1) {
            return false;
          }
          return true;
        } else {
          return false;
        }
      };
    }
  }

  //set count in the bottom of popup
  setCount() {
    let filterDataWithOutGroup = this.eaModifyProductDS.data.filter(
      (x) => !x.isGroupBy
    );
    let totalEaModifiableUnitsLocal = 0;
    filterDataWithOutGroup.map((x) => {
      totalEaModifiableUnitsLocal = totalEaModifiableUnitsLocal + parseInt(x.eaModifiableUnits)
    });

    this.totalEaModifiableUnits = this.totalEaUnits - (this.totalOldEaModifiableUnits - totalEaModifiableUnitsLocal);
  }

  //call on change the units
  dealerUnitChange(action: string, productItem: any) {
    // get old data
    if (!productItem.eaModifiableUnits) {
      productItem.eaModifiableUnits = 0;
    }
    if (action == 'decrease') {
      const decValue = +productItem.eaModifiableUnits - 1;
      if (decValue > 0) {
        const valueBeforeDec = productItem.eaModifiableUnits;
        productItem.eaModifiableUnits = Math.floor(productItem.eaModifiableUnits / +productItem.conv) * +productItem.conv;
        if (valueBeforeDec == productItem.eaModifiableUnits) {
          productItem.eaModifiableUnits = (+productItem.eaModifiableUnits > +productItem.conv ? +productItem.eaModifiableUnits - +productItem.conv : 0);
        }
      }
      else {
        productItem.eaModifiableUnits = 0;
      }
    }
    else if (this.isNavModify) {
      var valueBeforeInc = productItem.eaModifiableUnits;
      productItem.eaModifiableUnits = Math.ceil(productItem.eaModifiableUnits / +productItem.conv) * +productItem.conv;
      if (valueBeforeInc == productItem.eaModifiableUnits) {
        productItem.eaModifiableUnits = (+productItem.eaModifiableUnits + +productItem.conv);
      }
    }
    this.validateLineItem(productItem, action);
  }

  //validate line on change the unit
  validateLineItem(item: any, action) {
    let oldLineValue = this.eaModifyProductDSCopy.filter(x => x.itemID == item.itemID)[0];
    const orignalModfiableUnits = oldLineValue.eaModifiableUnits;

    //validate conversion factor
    if (item.eaModifiableUnits != 0 && item.eaModifiableUnits % item.conv != 0 && item.conv > 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
      item.lineErrors.errors.push({ id: 'conv', error: 'Please re-enter your EA Modifiable Units in multiples of ' + item.conv });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    }

    //validate qualified item in modify screen
    if (this.isNavModify && (action == "increase" || item.eaModifiableUnits > orignalModfiableUnits)) {
      if (item.isItemQualified == false) {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'validItem');
        item.lineErrors.errors.push({ id: 'validItem', error: "EA Modifiable Units can’t be increased as " + item.itemNumber + "(" + item.itemDescription + ")" + " does not qualify" });
      }
      else {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'validItem');
        this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      }
    }

    //validate total eaunit and minimum unit for decrease screen
    if (!this.isNavModify) {
      let oldTotalEaModUnit = this.eaModifyProductDSCopy.filter((f) => f.groupId == item.groupId)
        .reduce((sum, item) => sum + +item.eaModifiableUnits, 0);

      let newTotalEaModUnit = this.eaModifyProductDS.data.filter((f) => f.groupId == item.groupId)
        .reduce((sum, item) => sum + +item.eaModifiableUnits, 0);

      let calculatedTotalEaUnit = item.totalEaUnits - (oldTotalEaModUnit - newTotalEaModUnit);

      if (calculatedTotalEaUnit < item.minimumUnits) {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'minExp');
        item.lineErrors.errors.push({ id: 'minExp', error: 'Total EA Units ' + calculatedTotalEaUnit + ' cannot be less than ' + item.minimumUnits + ' Units.' });
      }
      else {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'minExp');
        this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      }

      //validate if increasing value in decrease screen.
      if (item.eaModifiableUnits > orignalModfiableUnits) {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'incError');
        item.lineErrors.errors.push({ id: 'incError', error: item.itemNumber + "(" + item.itemDescription + ")" + ' EA Modifiable Units can be only decreased' });
      }
      else {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'incError');
        this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      }
    }

    if (item.lineErrors.errors.length > 0) {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.errorMsgs.push(item.lineErrors);
    }
    else {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    }

    //recalculate footer count
    this.setCount();

    this.errorMsgs.sort(function (row1, row2) {
      return row1.rowId - row2.rowId;
    });
    this.getCommonErrors(this.errorMsgs);
  }

  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock
    }
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.eaModifyProductDSCopy.length > 0 && this.eaModifyProductDS.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        let oldLineValue = this.eaModifyProductDSCopy.filter(x => x.itemID == element.itemID)[0];

        // get current object index
        const currentLineIndex = this.eaModifyProductDS.data.findIndex(x => x.rowId == element.rowId);

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          this.eaModifyProductDS.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
          this.bindDataSource(this.eaModifyProductDS.data, false);

          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != oldLineValue.rowId);

          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.rowId);
          this.getCommonErrors(this.errorMsgs);
        }
      }
      else {
        // replace whole object
        // this.dealerOrderDS.data = JSON.parse(JSON.stringify(this.dealerOrderListCopy));

        // To hide all errors after revert all changes
        this.eaModifyProductDS.data.forEach(x => {
          if (x.lineErrors.errors.length != 0) {
            var index = x.lineErrors.rowId - 1;
            let oldLineValue = this.eaModifyProductDSCopy.filter(y => y.itemID == x.itemID)[0];
            this.eaModifyProductDS.data[index] = JSON.parse(JSON.stringify(oldLineValue));
            this.showHideLineError(index);
          }
        });

        this.bindDataSource(this.eaModifyProductDS.data, false);
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#modify_error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#modify_error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = this.index + 1;
      $('#modifyTableContainer').scrollTop = 0;
      if ($('#modify_error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#modify_error_' + this.nextErrorId.toString()).offset().top;
        $('#modifyTableContainer').animate({ scrollTop: nextOffset }, 1000);
      }
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = 1;
      $('#modifyTableContainer').scrollTop = 0;
      $('#modifyTableContainer').animate({ scrollTop: 0 }, 1000);
    }
  }

  //update request from UI
  SaveChanges() {
    if (this.isNavModify) {
      this.UpdateOrder();
    }
    else {
      this.UpdateAfterValidate();
    }
  }

  //on update button action
  UpdateOrder() {
    this.loaderService.setLoaderStatus(true);
    let payloadValidations = []
    this.eaModifyProductDS.data.map((x) => {
      if (!x.isGroupBy) {
        let tempObj = {
          'dealerOrderItemId': x.dealerOrderItemId,
          'dealerOrderId': x.dealerOrderID,
          'itemId': x.itemID,
          'isSeedEAItemInclusion': false,
          'isSeedEAAccountItemExclusion': false,
          'isDeactivationTypeSuspended': false,
        }
        payloadValidations.push(tempObj)
      }
    })
    this.subscription.push(this.dealerService.validateEaModifiableUnitsItem(payloadValidations).subscribe(results => {
      if (results) {
        //set validation field in grid model
        results.map((x) => {
          let data = this.eaModifyProductDS.data.find((y) => y.dealerOrderItemId == x.dealerOrderItemId);
          data.isItemQualified = x.isSeedEAItemInclusion && !x.isSeedEAAccountItemExclusion && !x.isDeactivationTypeSuspended;
        });
      }
      this.convertDataForDS(this.eaModifyProductDS.data.filter((x) => !x.isGroupBy));
      this.UpdateAfterValidate()
    }, (error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    })));
  }

  //show error on update if any
  UpdateAfterValidate() {
    let isValidateError = false;
    this.eaModifyProductDSCopy = JSON.parse(JSON.stringify(this.dealerService.selectedProductForModificaion));
    let payload = []
    if (this.isNavModify) {
      this.eaModifyProductDS.data.map((x) => {
        let oldLineValue = this.eaModifyProductDSCopy.filter(y => y.itemID == x.itemID)[0];
        if (!x.isGroupBy && x.eaModifiableUnits > oldLineValue.eaModifiableUnits) {
          this.validateLineItem(x, "increase");
        }
      })
    }

    this.eaModifyProductDS.data.map((x) => {
      let oldLineValue = this.eaModifyProductDSCopy.filter(y => y.itemID == x.itemID)[0];
      if (x.lineErrors.errors.length > 0) {
        isValidateError = true
      }
      if (!x.isGroupBy) {
        if (x.eaModifiableUnits != oldLineValue.eaModifiableUnits) {
          let tempObj = {
            'dealerOrderItemId': x.dealerOrderItemId,
            'itemId': x.itemID,
            'EaModifiableUnits': x.eaModifiableUnits,
            'prevEaModifiableUnits': oldLineValue.eaModifiableUnits,
            'accountNumber': this.accountNumber,
            'isModifyScreen': this.isNavModify
          }
          payload.push(tempObj)
        }
      }
    });
    this.loaderService.setLoaderStatus(false);
    if (!isValidateError) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.dealerService.UpdateEaUnitsItems(payload).subscribe(results => {
        if (results) {
          this.toastrService.success("EA Order # " + this.webOrderNumber + " has been successfully Updated.")
          this.eaProductModifyDecreaseUnitSliderModelService.close();
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          this.router.navigate(['/orders/dealer-order-view', 0, this.dealerOrderId, this.accountNumber]);
        }
      }, (error => {
        LolLoggerService.error(error);
        this.loaderService.setLoaderStatus(false);
      })));
    }
  }

  //make the field number only
  keyPressNumbers(event) {
    const numbers = /^[-+]?[0-9]+$/;
    if (!numbers.test(event.key)) {
      return false;
    }
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock
  }

  //ngAfterViewInit
  ngAfterViewInit(): void { }
}
